<ng-container *ngIf="dialogData?.tournament">
    <div class="page-body">
        <h1 class="tournament-games-heading" i18n>Tournament Games:</h1>
        <div class="tournament-wrapper" *ngIf="isLogin" fxLayout="row">
            <!-- <app-tournament-info-box *ngIf="dialogData.isInGame || !isLogin" [isModalDisplay]="true" [tournament]="dialogData.tournament">
            </app-tournament-info-box> -->
            <div *ngIf="dialogData?.tournament?.streamingChannelName" class="streaming-container">
                <app-tournament-streaming [channelName]="dialogData?.tournament?.streamingChannelName"></app-tournament-streaming>
            </div>
            <ng-container *ngIf="!dialogData?.tournament?.streamingChannelName">
                <div class="game-wrapper" fxLayoutAlign="center center">
                    <div class="tournament-start-game" *ngIf="!dialogData.isInGame && isLogin && tournament.games.length === 1">
                        <div class="thumbnail" >
                            <img src="{{ tournament.games[0]?.thumbnail.url }}" />
                        </div>
                        <div class="game-info">
                            <h1 class="game-title" mat-dialog-title>{{dialogData.tournament.games[0].name}}</h1>
                            <button *loggedRender round-button filled="filled" color="warn" class="launch-game" (click)="launchGame(dialogData.tournament.games[0].gameid,dialogData.tournament.games[0].name)" i18n>play game</button>
                        </div>
                    </div>
                </div>
                <swiper *ngIf="isLogin && tournament.games.length > 1" fxFlex="auto" class="operator-swiper" [config]="config">
                    <ng-template swiperSlide *ngFor="let game of tournament.games">
                        <div class="tournament-game-card" (click)="launchGame(game.gameid,game.systemName)" fxLayoutAlign="center center" fxLayout="column">
                            <div class="thumbnail">
                                <img src="{{ game.thumbnail?.url }}" />
                            </div>
                            <div class="title" mat-dialog-title>{{game.name}}</div>
                        </div>
                    </ng-template>
                </swiper>
            </ng-container>

        </div>
        <ng-container *ngIf="isActive">
            <div *ngIf="dialogData.tournament.displayBonusName" class="bonus-info">
                <img src="assets/icons/icon-info-32.svg">
                <div><span i18n>You must have an active bonus to participate in the tournament</span>&nbsp;{{dialogData.tournament.displayBonusName}}</div>
            </div>
            <div *ngIf="dialogData.tournament.tournamentMaximumRebuys && isLogin && dialogData.tournament.displayBonusName" fxLayoutAlign="space-between center" fxLayout="row" class="rebuy-info">
                <div>
                    <div style="margin-bottom: 4px;">
                        <span *ngIf="!tournamentRebuyAddPoints" i18n>Rebuy tournament bonus</span>
                        <span *ngIf="tournamentRebuyAddPoints" i18n>Rebuy tournament bonus and get {{tournamentRebuyAddPoints}} points</span>
                    </div>
                    <div><span i18n>available to rebuy</span>: &nbsp;{{availableRebuys}}&nbsp;/&nbsp;<span i18n>acquired</span>:&nbsp;{{rebuysUsed}}</div>
                </div>
                <ng-container *ngIf="balance$ | async as balance">
                    <div class="rebuy-button" *ngIf="availableRebuys>0" fxLayoutAlign="center center" fxLayoutGap="5px" fxLayout="column">
                        <button *ngIf="balance.balance>=rebuyPrice else notenoughfunds" round-button filled="empty" color="warn" size="small" (click)="checkConfirmRebuy()" [disabled]="!isSumbitRebuyAllowed" i18n>buy</button>
                        <div class="rebuy-price">(<span i18n>Price: </span>{{rebuyPrice}} {{currency}})</div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <div class="separtor"></div>

        <!-- <router-outlet></router-outlet> -->
        <div class="support-tab tournament-tab mobile" *ngIf="isRegularTournament()">

            <mat-tab-group headerPosition="below" mat-stretch-tabs [selectedIndex]="tabIndex" (selectedTabChange)="onTabChange($event)">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <img src="{{licenceService.getKey('icon-how-works')}}">
                        <p i18n>Info</p>
                    </ng-template>
                    <app-tournament-rules [tournament]="dialogData.tournament"></app-tournament-rules>

                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <img src="{{licenceService.getKey('icon-leader')}}">
                        <p i18n>Leaderboard</p>
                    </ng-template>
                    <app-tournament-overview [ref]="dialogData.tournament.ref" [tournament]="dialogData.tournament">
                    </app-tournament-overview>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <img src="{{licenceService.getKey('icon-prize')}}">
                        <p i18n>Prizes</p>
                    </ng-template>
                    <app-tournament-prizes [tournament]="dialogData.tournament"></app-tournament-prizes>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <img src="{{licenceService.getKey('icon-score')}}">
                        <p i18n>Scoring</p>
                    </ng-template>
                    <app-tournament-points [tournament]="dialogData.tournament"></app-tournament-points>
                </mat-tab>
            </mat-tab-group>
        </div>
        <app-tournament-rules *ngIf="isNotRegularTournament() || isRegularTournament().tournamentType === 2" [tournament]="dialogData.tournament"></app-tournament-rules>


    </div>
</ng-container>
<app-close-dialog-button (closeEvent)="closeDialog()" [customClass]="'medium'"></app-close-dialog-button>
<ng-template #notenoughfunds>
    <div class="not-enough-funds-text">
        <span i18n>No funds</span>
    </div>
</ng-template>